import { is, isEmpty } from '@convenia/helpers'
import { defineRule } from 'vee-validate-next'

// Replicates vee-validate 3 behavior: rules other than `required` are skipped for empty values
export const extend = (ruleId, validator, { skipIfEmpty = true } = {}) => {
  const run = is(validator, 'Function')
    ? validator
    : async (...args) => {
      const validation = await validator.validate(...args)
      return validation || validator.message
    }

  const validation = skipIfEmpty
    ? (value, ...args) => (isEmpty(value) ? true : run(value, ...args))
    : run

  return defineRule(ruleId, validation)
}
